import React from "react";
import { Box, Typography, IconButton, Link, Container } from "@mui/material";
import { styled } from "@mui/system";
import FacebookTwoToneIcon from "@mui/icons-material/FacebookTwoTone";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import TranslatedText from "./TranslatedText";
import "../Styles/Footer.css";

const CustomFooter = styled(Box)(({ theme }) => ({
  backgroundColor: "#04254a",
  color: "#fff",
  marginTop: "auto",
}));

const CustomLink = styled(Link)(({ theme }) => ({
  color: "#fff",
  marginLeft: "3vw",
}));

function Footer() {
  return (
    <CustomFooter component="footer">
      <Container className="footer-container">
        <div className="box">
          <div className="customLinks">
            <CustomLink href="/">
              <TranslatedText defaultText="Головна" />
            </CustomLink>
            <CustomLink href="/activities">
              <TranslatedText defaultText="Діяльність" />
            </CustomLink>
            <CustomLink href="/calendar">
              <TranslatedText defaultText="Календар" />
            </CustomLink>
            <CustomLink href="/about-us">
              <TranslatedText defaultText="Про нас" />
            </CustomLink>
            <CustomLink href="/contact">
              <TranslatedText defaultText="Контакти" />
            </CustomLink>
          </div>

          <div className="footerIcons">
            <IconButton
              aria-label="facebook"
              color="inherit"
              href="https://www.facebook.com/groups/5080342115346191"
            >
              <FacebookTwoToneIcon />
            </IconButton>
            <IconButton aria-label="email" color="inherit" href="">
              <DraftsOutlinedIcon />
            </IconButton>
          </div>
          <h3 className="footer-h3">Vestfold og Telemark Ukrainske Forening</h3>
          <Typography variant="body1">
            <br></br>
            <div className="inform">2023 Atticum Nettløsning</div>
          </Typography>
        </div>
      </Container>
    </CustomFooter>
  );
}

export default Footer;
